'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgHelpCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M6 0a5.99 5.99 0 00-6 6c0 3.321 2.679 6 6 6s6-2.679 6-6-2.679-6-6-6zm0 1.286A4.68 4.68 0 0110.714 6 4.68 4.68 0 016 10.714 4.68 4.68 0 011.286 6 4.68 4.68 0 016 1.286zm-1.886 3.36C4.126 3.65 4.848 3 6.064 3c1.155 0 1.907.608 1.907 1.52 0 .562-.262.95-.82 1.273-.521.3-.665.471-.665.829V6.8H5.3v-.178c0-.622.106-.966.635-1.27.516-.304.65-.463.65-.798 0-.308-.251-.52-.609-.52-.364 0-.615.243-.627.611H4.114zM5.927 9.1c-.49 0-.78-.254-.78-.691 0-.441.29-.696.78-.696.49 0 .775.255.775.696 0 .437-.285.691-.775.691z", id: "Help-circle__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Help-circle__svg__a" })))));
}

module.exports = SvgHelpCircle;
//# sourceMappingURL=HelpCircle.js.map
